import { useFormik } from "formik";
import $ from "jquery";
import React, { useCallback, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import LOGO from "../assets/images/Globelink.png";
import {
  generateAadhaarOTPThunk,
  generateAgreementThunk,
  generateMandateTokenThunk,
  generateMobileOtpThunk,
  getMandateAmountThunk,
  registerExecutiveThunk,
  verifyAadhaarOTPThunk,
  verifyMobileOtpThunk,
} from "../redux/features/mandateSlice";
import {
  formatDebitDate,
  generateConsumerId,
  generateTransactionId,
  getEndDate,
} from "../utils/utilsFunction";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [aadhaarNo, setAadhaarNo] = useState("");
  const [client_id, setClientId] = useState("");
  const [isOTP, setIsOTP] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [aggree, setAggree] = useState("");
  const [id, setId] = useState("");
  const [aadhaarOtpValues, setAadhaarOtpValues] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [phoneOtpValues, setPhoneOtpValues] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [mandateAmt, setMandateAmt] = useState();
  const [fieldExecutiveData, setFieldExecutiveData] = useState({
    aadhaar_no: "",
    name: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    profile_photo: "",
    accountName: "",
    accountNo: "",
    ifscCode: "",
    maxAmount: "",
    debitStartDate: "",
    debitEndDate: "",
    transactionId: "",
    consumerId: "",
    mandateId: "",
  });

  const fieldExecutiveRef = useRef(fieldExecutiveData);

  const [previewImage, setPreviewImage] = useState(null);
  // const [showNameOnAgreement, setShowNameOnAgreement] = useState(false);

  const base64ToFile = async (base64String, fileName) => {
    return new Promise((resolve, reject) => {
      // Remove the Base64 prefix (if any)
      const base64Data = base64String.split(",")[1] || base64String;

      // Check if the Base64 string is valid
      if (!/^[A-Za-z0-9+/=]+$/.test(base64Data)) {
        console.error("Invalid Base64 string");
        return reject("Invalid Base64 string");
      }

      try {
        // Decode Base64 to binary string
        const byteCharacters = atob(base64Data);

        // Create a typed array from the binary string
        const byteArrays = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArrays[i] = byteCharacters.charCodeAt(i);
        }

        // Create a Blob with the binary data
        const blob = new Blob([byteArrays], { type: "image/png" });

        // Create a File object from the Blob and resolve with it
        const file = new File([blob], fileName, { type: blob.type });
        resolve(file);
      } catch (error) {
        console.error("Error decoding Base64 string: ", error);
        reject(error);
      }
    });
  };

  const handleResponse = (res) => {
    if (res?.paymentMethod?.paymentTransaction?.statusCode) {
      const statusCode = res.paymentMethod.paymentTransaction.statusCode;
      console.log("Payment Response:", res);

      switch (statusCode) {
        case "0300":
          console.log("Transaction Successful");
          break;

        case "0398":
          console.log("Transaction Initiated");
          const mandateDetails = {
            ...fieldExecutiveRef.current,
            mandateRegNo:
              res.paymentMethod.paymentTransaction.instruction?.id || "",
            responseCode: res.paymentMethod.paymentTransaction.statusCode,
            responseMessage:
              res.paymentMethod.paymentTransaction.statusMessage || "",
            responseStatus: "Initiated",
            transactionId:
              res.paymentMethod.paymentTransaction.txnId ||
              fieldExecutiveRef.current.transactionId,
            consumerId:
              res.paymentMethod.paymentTransaction.consumerId ||
              fieldExecutiveRef.current.consumerId,
            // Add form values
            name: executiveFormik.values.name,
            email: executiveFormik.values.email,
            phone: executiveFormik.values.phone,
            dob: executiveFormik.values.dob,
            gender: executiveFormik.values.gender,
            address: executiveFormik.values.address,
            city: executiveFormik.values.city,
            state: executiveFormik.values.state,
            country: executiveFormik.values.country,
            pincode: executiveFormik.values.pincode,
            accountName: executiveFormik.values.accountName,
            accountNo: executiveFormik.values.accountNo,
            ifscCode: executiveFormik.values.ifscCode,
          };

          console.log("Mandate Details:", mandateDetails);
          fieldExecutiveRef.current = mandateDetails;
          registerFieldExecutive();
          break;

        default:
          console.error("Transaction Failed", res);
          toast.error("Bank mandate registration failed");
      }
    } else {
      console.error("Invalid Response", res);
      toast.error("Invalid response from bank");
    }
  };

  const registerFieldExecutive = async () => {
    setLoading(true);
    try {
      if (!previewImage) {
        toast.error("Profile photo is required");
        setLoading(false);
        return;
      }

      // Convert base64 image to file
      const profilePhotoFile = await base64ToFile(
        previewImage,
        "profile_photo.png"
      );
      const formData = new FormData();

      // Create an object with all required fields and their values
      const requiredFields = {
        aadhaar_no: aadhaarNo,
        name: fieldExecutiveRef.current.name,
        email: fieldExecutiveRef.current.email,
        dob: fieldExecutiveRef.current.dob,
        gender: fieldExecutiveRef.current.gender,
        phone: fieldExecutiveRef.current.phone,
        address: fieldExecutiveRef.current.address,
        city: fieldExecutiveRef.current.city,
        state: fieldExecutiveRef.current.state,
        country: fieldExecutiveRef.current.country,
        pincode: fieldExecutiveRef.current.pincode,
        accountName: fieldExecutiveRef.current.accountName,
        accountNo: fieldExecutiveRef.current.accountNo,
        ifscCode: fieldExecutiveRef.current.ifscCode,
        mandateRegNo: fieldExecutiveRef.current.mandateRegNo,
        responseCode: fieldExecutiveRef.current.responseCode,
        responseMessage: fieldExecutiveRef.current.responseMessage,
        responseStatus: "Initiated",
        transactionId: fieldExecutiveRef.current.transactionId,
        consumerId: fieldExecutiveRef.current.consumerId,
        maxAmount: mandateAmt,
        debitStartDate: formatDebitDate(Date.now()),
        debitEndDate: getEndDate(Date.now()),
      };

      // Validate all required fields
      const missingFields = [];
      Object.entries(requiredFields).forEach(([key, value]) => {
        if (!value) {
          missingFields.push(key);
        }
      });

      if (missingFields.length > 0) {
        console.error("Missing required fields:", missingFields);
        toast.error(`Missing required fields: ${missingFields.join(", ")}`);
        setLoading(false);
        return;
      }

      // Add all fields to formData
      Object.entries(requiredFields).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // Add profile photo separately
      formData.append("profile_photo", profilePhotoFile);

      // Debug log
      console.log("Form Data being sent:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value instanceof File ? "File object" : value);
      }

      // Register executive with error handling
      const registerResponse = await dispatch(registerExecutiveThunk(formData));
      console.log("Register Response:", registerResponse);

      if (registerResponse.meta.requestStatus === "fulfilled") {
        setAggree(registerResponse.payload.data[0].agreement_url);
        setId(registerResponse.payload.data[0]._id);
        // After successful registration, generate agreement
        setStep(3);
      } else {
        console.error("Registration failed:", registerResponse);
        const errorMessage =
          registerResponse.payload?.message ||
          "Registration failed. Please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error in registration process:", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred during registration.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const generateAggree = async () => {
    try {
      const agreementData = {
        id,
        name: fieldExecutiveRef.current.name,
        email: fieldExecutiveRef.current.email,
        phone: fieldExecutiveRef.current.phone,
        dob: fieldExecutiveRef.current.dob,
        address: fieldExecutiveRef.current.address,
        city: fieldExecutiveRef.current.city,
        state: fieldExecutiveRef.current.state,
        pincode: fieldExecutiveRef.current.pincode,
        aadhaar_no: aadhaarNo,
        profile_photo: `data:image/png;base64,${previewImage}`,
        date: formatDebitDate(Date.now()),
        accountName: fieldExecutiveRef.current.accountName,
        accountNo: fieldExecutiveRef.current.accountNo,
        ifscCode: fieldExecutiveRef.current.ifscCode,
        signName: fieldExecutiveRef.current.name,
      };

      const agreementResponse = await dispatch(
        generateAgreementThunk(agreementData)
      );

      if (agreementResponse.meta.requestStatus === "fulfilled") {
        console.log(agreementResponse);
        navigate("/");
        toast.success(
          "Registration successful! Please review and accept the agreement."
        );
      } else {
        console.error("Agreement generation failed:", agreementResponse);
        toast.error("Failed to generate agreement. Please try again.");
      }
    } catch (error) {
      toast.error("Failed to generate agreement. Please try again.");
    }
  };

  const executiveFormik = useFormik({
    initialValues: {
      aadhaar_no: "",
      profile_photo: "",
      name: "",
      email: "",
      phone: "",
      gender: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      accountName: "",
      accountNo: "",
      ifscCode: "",
      agreement: false,
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      aadhaar_no: Yup.string()
        .required("Aadhaar number is required")
        .matches(/^\d{12}$/, "Aadhaar number must be 12 digits"),
      profile_photo: Yup.mixed().required("Profile photo is required"),
      name: Yup.string()
        .required("Name is required")
        .min(2, "Name must be at least 2 characters"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      phone: Yup.string()
        .required("Phone number is required")
        .matches(/^\d{10}$/, "Phone number must be 10 digits"),
      gender: Yup.string().required("Gender is required"),
      dob: Yup.string().required("Date of Birth is required"),
      address: Yup.string()
        .required("Address is required")
        .min(5, "Address must be at least 5 characters"),
      city: Yup.string().required("City is required"),
      state: Yup.string().required("State is required"),
      country: Yup.string().required("Country is required"),
      pincode: Yup.string()
        .required("Pincode is required")
        .matches(/^\d{6}$/, "Pincode must be 6 digits"),
      accountName: Yup.string()
        .required("Account Name is required")
        .min(2, "Account name must be at least 2 characters"),
      accountNo: Yup.string()
        .required("Account Number is required")
        .matches(
          /^\d{9,18}$/,
          "Account number must be between 9 and 18 digits"
        ),
      ifscCode: Yup.string()
        .required("IFSC Code is required")
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format"),
      agreement: Yup.boolean()
        .required("You must accept the agreement")
        .oneOf([true], "You must accept the agreement"),
    }),
    onSubmit: async (values) => {
      if (step === 3) {
        // Handle final submission after agreement acceptance
        navigate("/");
        return;
      }
      try {
        const requiredMandateDetails = {
          consumerId: generateConsumerId(),
          transactionId: generateTransactionId(),
          accountName: values.accountName,
          accountNo: values.accountNo,
          ifscCode: values.ifscCode,
          maxAmount: mandateAmt,
          debitStartDate: formatDebitDate(Date.now()),
          debitEndDate: getEndDate(Date.now()),
        };
        const response = await dispatch(
          generateMandateTokenThunk(requiredMandateDetails)
        );

        // // Convert Base64 to File
        // const profilePhotoFile = await base64ToFile(
        //   previewImage,
        //   "profile_photo.png"
        // );

        setFieldExecutiveData({
          aadhaar_no: aadhaarNo,
          name: values.name,
          email: values.email,
          phone: values.phone,
          dob: values.dob,
          gender: values.gender,
          address: values.address,
          city: values.city,
          state: values.state,
          country: values.country,
          pincode: values.pincode,
          profile_photo: "",
          accountName: values.accountName,
          accountNo: values.accountNo,
          ifscCode: values.ifscCode,
          maxAmount: values.maxAmount,
          debitStartDate: values.debitStartDate,
          debitEndDate: values.debitEndDate,
          transactionId: requiredMandateDetails.transactionId,
          consumerId: requiredMandateDetails.consumerId,
        });

        // Check if response has the token
        const token = response.payload.token;

        if (!token) {
          console.error("Token generation failed.");
          return;
        }
        // Check if pnCheckout is available on window
        if (typeof window.$.pnCheckout === "undefined") {
          console.error("pnCheckout is not available on window.$");
          return;
        }
        // Prepare the configuration for the payment
        const configJson = {
          features: {
            showPGResponseMsg: true,
            enableAbortResponse: true,
            enableNewWindowFlow: true, //for hybrid applications please disable this by passing false
            enableExpressPay: true,
            siDetailsAtMerchantEnd: true,
            enableSI: true,
          },
          consumerData: {
            deviceId: "WEBSH2",
            token: token,
            returnUrl: "",
            responseHandler: handleResponse,
            paymentMode: "netBanking",
            merchantLogoUrl: LOGO,
            merchantId: "L906797",
            currency: "INR",
            consumerId: requiredMandateDetails.consumerId,
            txnId: requiredMandateDetails.transactionId,
            items: [
              {
                itemId: "first",
                amount: "1",
                comAmt: "0",
              },
            ],
            customStyle: {
              PRIMARY_COLOR_CODE: "#75000e",
              SECONDARY_COLOR_CODE: "#E9E9E9",
              BUTTON_COLOR_CODE_1: "#012647",
              BUTTON_COLOR_CODE_2: "#FFFFFF",
            },
            accountNo: requiredMandateDetails.accountNo,
            accountHolderName: requiredMandateDetails.accountName,
            ifscCode: requiredMandateDetails.ifscCode,
            accountType: "Saving",
            debitStartDate: requiredMandateDetails.debitStartDate,
            debitEndDate: requiredMandateDetails.debitEndDate,
            maxAmount: requiredMandateDetails.maxAmount,
            amountType: "M",
            frequency: "ADHO",
          },
        };

        // Trigger the Worldline checkout flow
        window.$.pnCheckout(configJson);
        if (configJson.features.enableNewWindowFlow) {
          window.pnCheckoutShared.openNewWindow();
        }
      } catch (error) {
        console.error(
          "Error during token generation or payment initiation:",
          error
        );
      }
    },
  });

  // const agreementUrl = useSelector((state) => state.mandate.url);

  const handleAadhaarOtpChange = (e, index) => {
    const { value } = e.target;
    const key = e.key; // Get the key directly from the event
    const newOtpValues = [...aadhaarOtpValues];

    if (key === "Backspace") {
      // Handle backspace key
      if (!value && index > 0) {
        const prevInput = document.getElementById(`otp-${index - 1}`);
        prevInput && prevInput.focus();
      }
      newOtpValues[index] = ""; // Clear current input value
    } else {
      newOtpValues[index] = value; // Set current input value
      if (value && index < 5) {
        // Auto-focus the next input field
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput && nextInput.focus();
      }
    }
    setAadhaarOtpValues(newOtpValues);
  };

  const handlePhoneOtpChange = (e, index) => {
    const { value } = e.target;
    const key = e.key; // Get the key directly from the event
    const newOtpValues = [...phoneOtpValues];

    if (key === "Backspace") {
      // Handle backspace key
      if (!value && index > 0) {
        const prevInput = document.getElementById(`otp-${index - 1}`);
        prevInput && prevInput.focus();
      }
      newOtpValues[index] = ""; // Clear current input value
    } else {
      newOtpValues[index] = value; // Set current input value
      if (value && index < 5) {
        // Auto-focus the next input field
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput && nextInput.focus();
      }
    }
    setPhoneOtpValues(newOtpValues);
  };

  const handleGenerateAadhaarOtp = async () => {
    setLoading(true);
    try {
      await dispatch(generateAadhaarOTPThunk(aadhaarNo)).then((data) => {
        if (data.meta.requestStatus === "fulfilled") {
          setIsOTP(true);
          setClientId(data.payload.data.client_id);
          toast.success(data.payload.message);
        }
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      toast.error(error || "Failed to send the otp");
    }
  };

  const handleVerifyAadhaarOtp = async () => {
    setLoading(true);
    try {
      const verifyData = {
        client_id: client_id,
        otp: aadhaarOtpValues.join(""),
      };
      await dispatch(verifyAadhaarOTPThunk(verifyData)).then((data) => {
        if (data.meta.requestStatus === "fulfilled") {
          const aadhaarData = data.payload.data.data;
          setIsAadhaarVerified(true);
          setIsOTP(false);
          toast.success(data.payload.message);

          setPreviewImage(aadhaarData?.profile_image);

          executiveFormik.setFieldValue("aadhaar_no", aadhaarNo || "");
          executiveFormik.setFieldValue("name", aadhaarData?.full_name || "");
          executiveFormik.setFieldValue("dob", aadhaarData?.dob || "");
          executiveFormik.setFieldValue("gender", aadhaarData?.gender || "");
          executiveFormik.setFieldValue(
            "address",
            `${aadhaarData?.address?.house}${aadhaarData?.address?.street}${aadhaarData?.address?.landmark}` ||
              ""
          );
          executiveFormik.setFieldValue(
            "city",
            aadhaarData?.address?.dist || ""
          );
          executiveFormik.setFieldValue(
            "state",
            aadhaarData?.address?.state || ""
          );
          executiveFormik.setFieldValue(
            "country",
            aadhaarData?.address?.country || ""
          );
          executiveFormik.setFieldValue("pincode", aadhaarData?.zip || "");
        }
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      toast.error(error || "Failed to verify the aadhaar no");
    }
  };

  const handleGeneratePhoneOtp = async () => {
    setLoading(true);
    try {
      console.log(executiveFormik.values.phone);
      await dispatch(generateMobileOtpThunk(executiveFormik.values.phone)).then(
        (data) => {
          console.log(data);
          if (data.meta.requestStatus === "fulfilled") {
            setIsPhone(true);
            toast.success(data.payload.message);
          }
          setLoading(false);
        }
      );
    } catch (error) {
      setLoading(false);
      toast.error(error || "Failed to send the otp");
    }
  };

  const handleVerifyPhoneOtp = async () => {
    setLoading(true);
    try {
      const verifyData = {
        phone: executiveFormik.values.phone,
        otp: phoneOtpValues.join(""),
      };
      await dispatch(verifyMobileOtpThunk(verifyData)).then((data) => {
        if (data.meta.requestStatus === "fulfilled") {
          setIsPhoneVerified(true);
          setIsPhone(false);
          toast.success(data.payload.message);
        }
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      toast.error(error || "Failed to verify the otp");
    }
  };

  const nextStep = async () => {
    let canProceed = false;

    if (step === 1) {
      // Check if Aadhaar is verified and all required fields in step 1 are filled
      const step1Fields = [
        "name",
        "email",
        "phone",
        "gender",
        "dob",
        "address",
        "city",
        "state",
        "country",
        "pincode",
      ];

      const isStep1Valid = step1Fields.every(
        (field) =>
          executiveFormik.values[field] && !executiveFormik.errors[field]
      );

      if (!isAadhaarVerified) {
        toast.error("Please verify your Aadhaar number first");
        return;
      }

      if (!isPhoneVerified) {
        toast.error("Please verify your phone number first");
        return;
      }

      if (!isStep1Valid) {
        toast.error("Please fill all required fields correctly");
        // Touch all fields to show validation errors
        step1Fields.forEach((field) => {
          executiveFormik.setFieldTouched(field, true);
        });
        return;
      }

      canProceed = true;
    }

    if (step === 2) {
      // Check if all required fields in step 2 are filled
      const step2Fields = ["accountName", "accountNo", "ifscCode"];

      const isStep2Valid = step2Fields.every(
        (field) =>
          executiveFormik.values[field] && !executiveFormik.errors[field]
      );

      if (!isStep2Valid) {
        toast.error("Please fill all mandate details correctly");
        // Touch all fields to show validation errors
        step2Fields.forEach((field) => {
          executiveFormik.setFieldTouched(field, true);
        });
        return;
      }

      // If validation passes, trigger the mandate token generation and bank selection
      try {
        const requiredMandateDetails = {
          consumerId: generateConsumerId(),
          transactionId: generateTransactionId(),
          accountName: executiveFormik.values.accountName,
          accountNo: executiveFormik.values.accountNo,
          ifscCode: executiveFormik.values.ifscCode,
          maxAmount: mandateAmt,
          debitStartDate: formatDebitDate(Date.now()),
          debitEndDate: getEndDate(Date.now()),
        };

        // Update fieldExecutiveData with current form values
        setFieldExecutiveData({
          ...fieldExecutiveData,
          ...executiveFormik.values,
          transactionId: requiredMandateDetails.transactionId,
          consumerId: requiredMandateDetails.consumerId,
        });

        const response = await dispatch(
          generateMandateTokenThunk(requiredMandateDetails)
        );

        // Check if response has the token
        const token = response.payload.token;

        if (!token) {
          toast.error("Failed to generate mandate token");
          return;
        }

        // Configure and trigger Worldline checkout
        const configJson = {
          features: {
            showPGResponseMsg: true,
            enableAbortResponse: true,
            enableNewWindowFlow: true,
            enableExpressPay: true,
            siDetailsAtMerchantEnd: true,
            enableSI: true,
          },
          consumerData: {
            deviceId: "WEBSH2",
            token: token,
            returnUrl: "",
            responseHandler: handleResponse,
            paymentMode: "netBanking",
            merchantLogoUrl: LOGO,
            merchantId: "L906797",
            currency: "INR",
            consumerId: requiredMandateDetails.consumerId,
            txnId: requiredMandateDetails.transactionId,
            items: [
              {
                itemId: "first",
                amount: "1",
                comAmt: "0",
              },
            ],
            customStyle: {
              PRIMARY_COLOR_CODE: "#75000e",
              SECONDARY_COLOR_CODE: "#E9E9E9",
              BUTTON_COLOR_CODE_1: "#012647",
              BUTTON_COLOR_CODE_2: "#FFFFFF",
            },
            accountNo: requiredMandateDetails.accountNo,
            accountHolderName: requiredMandateDetails.accountName,
            ifscCode: requiredMandateDetails.ifscCode,
            accountType: "Saving",
            debitStartDate: requiredMandateDetails.debitStartDate,
            debitEndDate: requiredMandateDetails.debitEndDate,
            maxAmount: requiredMandateDetails.maxAmount,
            amountType: "M",
            frequency: "ADHO",
          },
        };

        // Trigger the Worldline checkout flow
        if (window.$.pnCheckout) {
          window.$.pnCheckout(configJson);
          if (configJson.features.enableNewWindowFlow) {
            window.pnCheckoutShared.openNewWindow();
          }
        } else {
          toast.error("Payment gateway is not available");
          return;
        }
      } catch (error) {
        toast.error("Failed to initiate bank selection");
        console.error("Error:", error);
        return;
      }

      // Don't proceed to next step here - wait for handleResponse callback
      return;
    }

    if (canProceed) {
      setStep((prev) => (prev < 3 ? prev + 1 : prev));
    }
  };

  const prevStep = () => {
    setStep((prev) => {
      if (prev === 1) {
        navigate("/"); // Delay navigation slightly
        return prev; // Keep the step unchanged as it's already at 1
      }
      return prev - 1; // Decrement step otherwise
    });
  };

  const getMandateAmount = useCallback(() => {
    dispatch(getMandateAmountThunk({})).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        setMandateAmt(data.payload.data.amount);
      } else {
        toast.error(data.payload);
      }
    });
  }, [dispatch, setMandateAmt]);

  useEffect(() => {
    getMandateAmount();
  }, [getMandateAmount]);

  useEffect(() => {
    fieldExecutiveRef.current = fieldExecutiveData;
  }, [fieldExecutiveData]);

  // mandate popup useeffect
  useEffect(() => {
    // Expose jQuery globally
    window.$ = $;
    window.jQuery = $;

    // Dynamically load the checkout.js script
    const script = document.createElement("script");
    script.src =
      "https://www.paynimo.com/Paynimocheckout/server/lib/checkout.js";
    script.async = true;
    script.onload = () => {
      console.log("Checkout.js loaded successfully");
    };
    script.onerror = () => {
      console.error("Failed to load Checkout.js");
    };
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  // Update the label components to show required indicator
  const RequiredLabel = ({ htmlFor, children }) => (
    <label
      htmlFor={htmlFor}
      className="block text-[#67221A] font-semibold mb-1"
    >
      {children} <span className="text-red-500">*</span>
    </label>
  );

  return (
    <div
      className="w-full min-h-screen flex items-center justify-center relative overflow-y-auto"
      style={{
        background: `linear-gradient(135deg, #67221A 50%, #FFFFFF 50%)`,
      }}
    >
      <div className="w-full max-w-4xl p-4 md:p-6 lg:p-8 bg-white rounded-lg shadow-lg z-10">
        <form onSubmit={executiveFormik.handleSubmit}>
          {step === 1 && (
            <>
              <fieldset className="border border-[#67221A] rounded p-4">
                <legend className="text-[#67221A] font-semibold px-2">
                  Verify Aadhaar
                </legend>
                <div className="grid grid-cols-1 gap-4 items-center md:grid-cols-4">
                  {/* Aadhaar Input and Verification Status */}
                  <div className="relative w-full col-span-3 px-2 py-2 border border-gray-300 rounded">
                    <input
                      id="aadhaar_no"
                      name="aadhaar_no"
                      type="number"
                      value={aadhaarNo}
                      onChange={(e) => {
                        setAadhaarNo(e.target.value);
                        setFieldExecutiveData({
                          ...fieldExecutiveData,
                          aadhaar_no: e.target.value,
                        });
                      }}
                      disabled={aadhaarNo && isAadhaarVerified}
                      aria-label="Aadhaar Number"
                      className="w-full p-2 pr-20 border-none focus:outline-none rounded-md focus:ring-2 text-black focus:ring-[#67221A] placeholder-gray-500"
                      placeholder="Enter Aadhaar Number"
                    />
                    <div
                      className={`absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-1 px-2 py-1 text-xs md:text-sm rounded ${
                        isAadhaarVerified
                          ? "bg-green-50 text-green-800 border border-green-500"
                          : "bg-red-50 text-red-800 border border-red-500"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d={
                            isAadhaarVerified
                              ? "M5 13l4 4L19 7" // Check icon
                              : "M6 18L18 6M6 6l12 12" // Cross icon
                          }
                        />
                      </svg>
                      <span className="font-medium whitespace-nowrap">
                        {isAadhaarVerified ? "VERIFIED" : "NOT VERIFIED"}
                      </span>
                    </div>
                  </div>

                  {/* Verify Button */}
                  <button
                    type="button"
                    disabled={isAadhaarVerified || loading}
                    onClick={handleGenerateAadhaarOtp}
                    className={`col-span-1 py-2 rounded-md text-white font-semibold transition-all duration-300 ${
                      isAadhaarVerified || loading
                        ? "bg-gray-500 cursor-wait opacity-50"
                        : "bg-[#67221A] cursor-pointer hover:bg-[#011f37]"
                    }`}
                  >
                    {loading ? "Processing..." : "Verify"}
                  </button>
                </div>

                {/* OTP Modal */}
                {isOTP && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 transition-opacity duration-300">
                    <div className="bg-white w-full max-w-md mx-4 md:mx-auto rounded-lg shadow-lg p-6 md:p-8 relative">
                      <button
                        onClick={() => {
                          setIsOTP(false);
                          setAadhaarOtpValues(["", "", "", "", "", ""]);
                        }}
                        className="absolute top-4 right-4 text-white px-3 py-1 bg-[#67221A] rounded-full hover:bg-opacity-50 transition text-xl font-bold"
                        aria-label="Close"
                      >
                        &times;
                      </button>
                      <h2 className="text-[#012647] text-xl md:text-2xl font-bold mb-6 text-center">
                        Enter OTP
                      </h2>
                      <p className="text-center text-gray-600 mb-4 text-sm md:text-base">
                        Please enter the 4-digit OTP sent to your registered
                        mobile number.
                      </p>
                      <div className="grid grid-cols-6 gap-4 text-center">
                        {aadhaarOtpValues.map((value, index) => (
                          <input
                            key={index}
                            id={`otp-${index}`}
                            type="text"
                            value={value}
                            maxLength={1}
                            onKeyDown={(e) => handleAadhaarOtpChange(e, index)}
                            onChange={(e) => handleAadhaarOtpChange(e, index)}
                            className="col-span-1 h-12 border border-gray-300 rounded text-center text-2xl text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                          />
                        ))}
                      </div>
                      <div className="flex justify-end space-x-4 mt-4">
                        <button
                          type="button"
                          onClick={() => {
                            setIsOTP(false);
                            setAadhaarOtpValues(["", "", "", "", "", ""]);
                          }}
                          className="px-6 py-3 bg-gray-300 rounded-full text-[#67221A] font-semibold"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          disabled={loading}
                          onClick={handleVerifyAadhaarOtp}
                          className={`px-6 py-3 bg-[#67221A] rounded-full text-white font-semibold ${
                            loading ? "cursor-wait" : "cursor-pointer"
                          }`}
                        >
                          {loading ? "Processing..." : "Submit"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </fieldset>

              <fieldset className="border border-[#67221A] rounded p-4">
                <legend className="text-[#67221A] font-semibold px-1">
                  Executive Details
                </legend>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div
                    className="col-span-1 border border-gray-300 rounded p-4 relative cursor-pointer"
                    onClick={() =>
                      document.getElementById("fileInput")?.click()
                    }
                  >
                    <input
                      type="file"
                      id="fileInput"
                      className="hidden"
                      accept="image/*"
                    />
                    {previewImage ? (
                      <img
                        src={`data:image/png;base64,${previewImage}`}
                        alt="Preview"
                        className="w-full h-full object-cover rounded"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm sm:text-base">
                        Click to upload an image
                      </div>
                    )}
                  </div>
                  <div className="col-span-3 space-y-4">
                    <div>
                      <RequiredLabel htmlFor="name">Name</RequiredLabel>
                      <input
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Enter Your Name"
                        value={executiveFormik.values.name}
                        disabled={
                          executiveFormik.values.name && isAadhaarVerified
                            ? true
                            : false
                        }
                        onChange={executiveFormik.handleChange}
                        onBlur={executiveFormik.handleBlur}
                        className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A] text-sm md:text-base"
                      />
                      {executiveFormik.touched.name &&
                        executiveFormik.errors.name && (
                          <div className="text-[#75000e] text-sm mt-1">
                            {executiveFormik.errors.name}
                          </div>
                        )}
                    </div>
                    <div>
                      <RequiredLabel htmlFor="email">Email</RequiredLabel>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Enter Your Email"
                        value={executiveFormik.values.email}
                        onChange={executiveFormik.handleChange}
                        onBlur={executiveFormik.handleBlur}
                        className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A] text-sm md:text-base"
                      />
                      {executiveFormik.touched.email &&
                        executiveFormik.errors.email && (
                          <div className="text-[#75000e] text-sm mt-1">
                            {executiveFormik.errors.email}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="col-span-4">
                    <div className="flex flex-col md:flex-row md:items-center md:space-x-4 space-y-4 md:space-y-0">
                      {/* Gender Input */}
                      <div className="flex-1">
                        <RequiredLabel htmlFor="gender">Gender</RequiredLabel>
                        <select
                          id="gender"
                          name="gender"
                          value={executiveFormik.values.gender}
                          onChange={executiveFormik.handleChange}
                          onBlur={executiveFormik.handleBlur}
                          disabled={
                            executiveFormik.values.gender && isAadhaarVerified
                              ? true
                              : false
                          }
                          className={`w-full p-2 border rounded text-black focus:outline-none focus:ring-2 text-sm ${
                            executiveFormik.errors.gender &&
                            executiveFormik.touched.gender
                              ? "border-red-500 focus:ring-red-500"
                              : "border-gray-300 focus:ring-[#67221A]"
                          }`}
                        >
                          <option value="">Select Gender</option>
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                          <option value="O">Others</option>
                        </select>
                        {executiveFormik.touched.gender &&
                          executiveFormik.errors.gender && (
                            <div className="text-[#75000e] text-sm mt-1">
                              {executiveFormik.errors.gender}
                            </div>
                          )}
                      </div>

                      {/* DOB Input */}
                      <div className="flex-1">
                        <RequiredLabel htmlFor="dob">DOB</RequiredLabel>
                        <input
                          id="dob"
                          name="dob"
                          type="date"
                          value={executiveFormik.values.dob}
                          onChange={executiveFormik.handleChange}
                          onBlur={executiveFormik.handleBlur}
                          disabled={
                            executiveFormik.values.dob && isAadhaarVerified
                              ? true
                              : false
                          }
                          className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A] text-sm"
                        />
                        {executiveFormik.touched.dob &&
                          executiveFormik.errors.dob && (
                            <div className="text-[#75000e] text-sm mt-1">
                              {executiveFormik.errors.dob}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col-span-4">
                    <RequiredLabel htmlFor="phone">Phone</RequiredLabel>
                    <div className="grid grid-cols-1 gap-4 items-center md:grid-cols-4">
                      {/* Aadhaar Input and Verification Status */}
                      <div className="relative w-full col-span-3 px-2 py-2 border border-gray-300 rounded">
                        <input
                          id="phone"
                          name="phone"
                          type="tel"
                          value={executiveFormik.values.phone}
                          onChange={executiveFormik.handleChange}
                          onBlur={executiveFormik.handleBlur}
                          placeholder="Enter Your Phone Number"
                          disabled={isPhoneVerified}
                          className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A] text-sm"
                        />
                        <div
                          className={`absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-1 px-2 py-1 text-xs md:text-sm rounded ${
                            isPhoneVerified
                              ? "bg-green-50 text-green-800 border border-green-500"
                              : "bg-red-50 text-red-800 border border-red-500"
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d={
                                isPhoneVerified
                                  ? "M5 13l4 4L19 7" // Check icon
                                  : "M6 18L18 6M6 6l12 12" // Cross icon
                              }
                            />
                          </svg>
                          <span className="font-medium whitespace-nowrap">
                            {isPhoneVerified ? "VERIFIED" : "NOT VERIFIED"}
                          </span>
                        </div>
                      </div>
                      <button
                        type="button"
                        disabled={isPhoneVerified || loading}
                        onClick={handleGeneratePhoneOtp}
                        className={`w-full p-2 col-span-1 py-2 rounded text-white ${
                          isPhoneVerified || loading
                            ? "bg-gray-500 cursor-not-allowed"
                            : "bg-[#67221A] hover:bg-opacity-90"
                        }`}
                      >
                        {loading ? "Processing..." : "Verify"}
                      </button>
                      {isPhone === true && (
                        <>
                          <div
                            className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 transition-opacity duration-300`}
                          >
                            <div className="bg-white w-full max-w-md mx-4 md:mx-auto rounded-lg shadow-lg p-6 md:p-8 relative">
                              <button
                                onClick={() => {
                                  setIsPhone(false);
                                  setPhoneOtpValues(["", "", "", "", "", ""]);
                                }}
                                className="absolute top-4 right-4 text-white px-3 py-1 bg-[#67221A] rounded-full hover:bg-opacity-50 transition text-xl font-bold"
                                aria-label="Close"
                              >
                                &times;
                              </button>
                              <h2 className="text-[#012647] text-2xl md:text-2xl font-bold mb-6 text-center">
                                Enter OTP
                              </h2>
                              <p className="text-center text-gray-600 mb-4">
                                Please enter the 4-digit OTP sent to your
                                registered mobile number.
                              </p>

                              <form className="space-y-6">
                                <div className="grid grid-cols-6 gap-4 text-center">
                                  {phoneOtpValues.map((value, index) => (
                                    <input
                                      key={index}
                                      id={`otp-${index}`}
                                      type="text"
                                      value={value}
                                      maxLength={1}
                                      onKeyDown={(e) =>
                                        handlePhoneOtpChange(e, index)
                                      }
                                      onChange={(e) =>
                                        handlePhoneOtpChange(e, index)
                                      }
                                      className="w-12 h-12 border border-gray-300 rounded text-center text-2xl text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                                    />
                                  ))}
                                </div>

                                <div className="flex justify-end space-x-4 mt-4">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setIsPhone(false);
                                      setPhoneOtpValues([
                                        "",
                                        "",
                                        "",
                                        "",
                                        "",
                                        "",
                                      ]);
                                    }}
                                    className="px-6 py-3 bg-gray-300 rounded-full text-[#67221A] font-semibold"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    disabled={loading}
                                    onClick={handleVerifyPhoneOtp}
                                    className={`px-6 py-3 bg-[#67221A] rounded-full text-white font-semibold ${
                                      loading ? "cursor-wait" : "cursor-pointer"
                                    }`}
                                  >
                                    {loading ? "Processing..." : "Submit"}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-span-4 space-y-4">
                    {/* Address Field */}
                    <div>
                      <RequiredLabel htmlFor="address">Address</RequiredLabel>
                      <input
                        id="address"
                        name="address"
                        type="text"
                        placeholder="Enter Your Address"
                        value={executiveFormik.values.address}
                        onChange={executiveFormik.handleChange}
                        onBlur={executiveFormik.handleBlur}
                        disabled={
                          executiveFormik.values.address && isAadhaarVerified
                            ? true
                            : false
                        }
                        className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                      />
                      {executiveFormik.touched.address &&
                        executiveFormik.errors.address && (
                          <div className="text-[#75000e] text-sm mt-1">
                            {executiveFormik.errors.address}
                          </div>
                        )}
                    </div>

                    {/* Grid for City, State, Country, and Pincode */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                      {/* City */}
                      <div>
                        <RequiredLabel htmlFor="city">City</RequiredLabel>
                        <input
                          id="city"
                          name="city"
                          type="text"
                          placeholder="Enter Your City"
                          value={executiveFormik.values.city}
                          onChange={executiveFormik.handleChange}
                          onBlur={executiveFormik.handleBlur}
                          disabled={
                            executiveFormik.values.city && isAadhaarVerified
                              ? true
                              : false
                          }
                          className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                        />
                        {executiveFormik.touched.city &&
                          executiveFormik.errors.city && (
                            <div className="text-[#75000e] text-sm mt-1">
                              {executiveFormik.errors.city}
                            </div>
                          )}
                      </div>

                      {/* State */}
                      <div>
                        <RequiredLabel htmlFor="state">State</RequiredLabel>
                        <input
                          id="state"
                          name="state"
                          type="text"
                          placeholder="Enter Your State"
                          value={executiveFormik.values.state}
                          onChange={executiveFormik.handleChange}
                          onBlur={executiveFormik.handleBlur}
                          disabled={
                            executiveFormik.values.state && isAadhaarVerified
                              ? true
                              : false
                          }
                          className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                        />
                        {executiveFormik.touched.state &&
                          executiveFormik.errors.state && (
                            <div className="text-[#75000e] text-sm mt-1">
                              {executiveFormik.errors.state}
                            </div>
                          )}
                      </div>

                      {/* Country */}
                      <div>
                        <RequiredLabel htmlFor="country">Country</RequiredLabel>
                        <input
                          id="country"
                          name="country"
                          type="text"
                          placeholder="Enter Your Country"
                          value={executiveFormik.values.country}
                          onChange={executiveFormik.handleChange}
                          onBlur={executiveFormik.handleBlur}
                          disabled={
                            executiveFormik.values.country && isAadhaarVerified
                              ? true
                              : false
                          }
                          className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                        />
                        {executiveFormik.touched.country &&
                          executiveFormik.errors.country && (
                            <div className="text-[#75000e] text-sm mt-1">
                              {executiveFormik.errors.country}
                            </div>
                          )}
                      </div>

                      {/* Pincode */}
                      <div>
                        <RequiredLabel htmlFor="pincode">Pincode</RequiredLabel>
                        <input
                          id="pincode"
                          name="pincode"
                          type="number"
                          placeholder="Enter Your Pincode"
                          value={executiveFormik.values.pincode}
                          onChange={executiveFormik.handleChange}
                          onBlur={executiveFormik.handleBlur}
                          disabled={
                            executiveFormik.values.pincode && isAadhaarVerified
                              ? true
                              : false
                          }
                          className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                        />
                        {executiveFormik.touched.pincode &&
                          executiveFormik.errors.pincode && (
                            <div className="text-[#75000e] text-sm mt-1">
                              {executiveFormik.errors.pincode}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </>
          )}

          {step === 2 && (
            <>
              <fieldset className="border border-[#67221A] rounded p-4">
                <legend className="text-[#67221A] font-semibold px-2">
                  Mandate Details
                </legend>
                <div className="grid grid-cols-4 md:grid-cols-4 gap-4 pb-4">
                  <div className="col-span-4">
                    <label
                      htmlFor="accountName"
                      className="block text-[#67221A] font-semibold mb-1"
                    >
                      Account Name
                    </label>
                    <input
                      id="accountName"
                      name="accountName"
                      type="text"
                      value={executiveFormik.values.accountName}
                      onChange={executiveFormik.handleChange}
                      onBlur={executiveFormik.handleBlur}
                      className="col-span-2 w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                    />
                    {executiveFormik.touched.accountName &&
                      executiveFormik.errors.accountName && (
                        <div className="text-[#75000e] text-sm mt-1">
                          {executiveFormik.errors.accountName}
                        </div>
                      )}
                  </div>
                  <div className="col-span-2">
                    <label
                      htmlFor="accountNo"
                      className="block text-[#67221A] font-semibold mb-1"
                    >
                      Account No
                    </label>
                    <input
                      id="accountNo"
                      name="accountNo"
                      type="text"
                      value={executiveFormik.values.accountNo}
                      onChange={executiveFormik.handleChange}
                      onBlur={executiveFormik.handleBlur}
                      className="col-span-2 w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                    />
                    {executiveFormik.touched.accountNo &&
                      executiveFormik.errors.accountNo && (
                        <div className="text-[#75000e] text-sm mt-1">
                          {executiveFormik.errors.accountNo}
                        </div>
                      )}
                  </div>
                  <div className="col-span-2">
                    <label
                      htmlFor="ifscCode"
                      className="block text-[#67221A] font-semibold mb-1"
                    >
                      IFSC Code
                    </label>
                    <input
                      id="ifscCode"
                      name="ifscCode"
                      type="text"
                      value={executiveFormik.values.ifscCode}
                      onChange={executiveFormik.handleChange}
                      onBlur={executiveFormik.handleBlur}
                      className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                    />
                    {executiveFormik.touched.ifscCode &&
                      executiveFormik.errors.ifscCode && (
                        <div className="text-[#75000e] text-sm mt-1">
                          {executiveFormik.errors.ifscCode}
                        </div>
                      )}
                  </div>
                </div>
              </fieldset>
            </>
          )}

          {/* Step 3: Agreement */}
          {step === 3 && (
            <div>
              <h2 className="text-lg font-semibold mb-4 text-black">
                Agreement
              </h2>
              {/* Agreement Container */}
              <div className="relative">
                {aggree && (
                  <div className="relative">
                    <iframe
                      title="aggrement"
                      src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                        aggree
                      )}&embedded=true`}
                      className="w-full h-[500px] border rounded-lg mt-4"
                      style={
                        {
                          //   pointerEvents: "none",
                        }
                      }
                    />
                    {/* Removed the digital signature floating text */}
                    {/* Name Overlay - positioned behind "Digitally Signed by" */}
                    {executiveFormik.values.agreement && (
                      <div
                        className="absolute text-black"
                        style={{
                          bottom: "80px",
                          right: "120px",
                          zIndex: 50,
                          padding: "2px 4px",
                          fontSize: "14px",
                          fontWeight: "500",
                          fontFamily: "Arial, sans-serif",
                          lineHeight: "1.2",
                          textAlign: "center",
                        }}
                      >
                        {/* {executiveFormik.values.name} */}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <label className="flex items-center space-x-2 text-black mt-4">
                <input
                  name="agreement"
                  type="checkbox"
                  checked={executiveFormik.values.agreement}
                  onChange={(e) => {
                    executiveFormik.handleChange(e);
                    // setShowNameOnAgreement(e.target.checked);
                  }}
                  onBlur={executiveFormik.handleBlur}
                  className="h-4 w-4"
                />
                <span className="text-black">
                  I accept the terms and conditions
                </span>
              </label>

              {executiveFormik.touched.agreement &&
                executiveFormik.errors.agreement && (
                  <div className="text-red-500 text-sm">
                    {executiveFormik.errors.agreement}
                  </div>
                )}
            </div>
          )}

          <div className="flex justify-between mt-6">
            <button
              type="button"
              disabled={loading}
              className={`bg-[#67221A] text-white rounded-3xl px-4 py-2 font-semibold hover:bg-[#012647] ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={prevStep}
            >
              Back
            </button>
            <div className="flex items-center space-x-2">
              {[1, 2, 3].map((s) => (
                <div
                  key={s}
                  className={`h-3 w-8 rounded-xl ${
                    step >= s ? "bg-[#67221A]" : "bg-gray-300"
                  }`}
                ></div>
              ))}
            </div>

            {step < 3 ? (
              <button
                type="button"
                disabled={loading}
                className={`bg-[#67221A] text-white rounded-3xl px-4 py-2 font-semibold ${
                  loading
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-[#012647]"
                }`}
                onClick={nextStep}
              >
                {loading ? "Processing..." : "Next"}
              </button>
            ) : (
              <button
                type="submit"
                disabled={loading || !executiveFormik.values.agreement}
                className={`bg-[#67221A] text-white rounded-3xl px-4 py-2 font-semibold ${
                  loading || !executiveFormik.values.agreement
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-[#012647]"
                }`}
                onClick={() => {
                  if (step === 3) generateAggree();
                  // setTimeout(() => {
                  //   navigate("/register");
                  // }, 1500);
                }}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
